import * as React from "react";
import { AuthShell } from "@/components/mimin/login/AuthShell";

/**
 * Rammen rundt ra-supabase sine egne autentiseringssider (glemt passord, sett
 * nytt passord). Peker på det samme skallet som innloggingen, så reisen fra
 * «Glemt passord?» og tilbake ser ut som én flate.
 *
 * Sidene tegner sin egen overskrift inne i kortet, så skallet får ingen tittel
 * her — bare logo, kort og notifikasjoner.
 */
export const Layout = ({ children }: React.PropsWithChildren) => (
  <AuthShell>
    <div className="space-y-6">{children}</div>
  </AuthShell>
);
